import cs from 'classnames';

import MainNavigation from '../../components/MainNavigation';
import NavFooter from '../../components/NavFooter';
import useNavData from '../../hooks/useNavData';

import { StyledNavigationContainer } from '../../styles';
import useNavFilter from './hooks/useNavFilter';

const NavigationContainer = () => {
  const {
    isCollapsed,
    navConfig,
    onTransitionEnd,
    toggleNavigation,
    transitionInProgress,
    autoCollapse,
  } = useNavData();

  const { filteredNavConfig } = useNavFilter({ navConfig });

  return (
    <StyledNavigationContainer
      data-testid={`main-navigation-container-${isCollapsed ? 'collapsed' : 'expanded'}`}
      className={cs('learner-navigation-wrapper', {
        'expanded-state': !isCollapsed,
        'collapsed-state': isCollapsed,
        'transition-active': transitionInProgress,
      })}
    >
      <MainNavigation
        isExpanded={!isCollapsed}
        navConfig={filteredNavConfig}
        onTransitionEnd={onTransitionEnd}
      />
      <NavFooter
        toggleNavigation={toggleNavigation}
        autoCollapse={autoCollapse}
        isCollapsed={isCollapsed}
        isAdmin={false}
      />
    </StyledNavigationContainer>
  );
};

export default NavigationContainer;
